import { IOffer } from "@nju/data-access-portal-offers";

interface ISetDefaultOfferProps {
  offers: IOffer[];
}

export function setDefaultOffer({ offers }: ISetDefaultOfferProps) {
  if (offers.length === 1) {
    return offers[0];
  }

  if (offers.length === 2) {
    return offers[1];
  }

  return offers[offers.length - 2];
}
